module.exports = __webpack_public_path__ + "img/venus28.ecbf3580.png";